import React from 'react'

import { ICellEditorParams } from 'ag-grid-community'

import { WQStageSelector } from '@/features/WorkQueues/WQStageSelector'

export const StageSelectorCellEditor = (props: ICellEditorParams) => {
  return (
    <WQStageSelector
      application={props.data}
      parentCellProps={props}
    />
  )
}
